export default __webpack_public_path__ + "static/media/black_m_le_plus_fort_du_monde.5c28d4ce.mp3";